export const BRAND = {
  // Original artwork (white circular backing) — for light surfaces.
  logo: {
    xl: "/gpu-logo-512.webp",
    lg: "/gpu-logo-256.webp",
    md: "/gpu-logo-256.png",
    sm: "/gpu-logo-96.png",
    xs: "/gpu-logo-48.png",
  },
  // Background removed (transparent outside the seal) — for navy / dark surfaces.
  logoTransparent: {
    xl: "/gpu-logo-t-512.webp",
    lg: "/gpu-logo-t-256.webp",
    md: "/gpu-logo-t-256.png",
    sm: "/gpu-logo-t-96.png",
    xs: "/gpu-logo-t-48.png",
  },
  logoAlt: "Gujarat Pharma Union official emblem — Unity, Compliance, Protection, Progress",
};
